import { spaceTypes } from '../spaceTypes';
import countries from 'constants/countries';
import { getSize, getHeadcountBasedQuantites } from './utils';

export const specific = [
  {
    id: 1,
    name: 'spaceTypes.specific.infirmarySickBay',
    displayOrder: 1,
    spaceTypeId: spaceTypes.specific.id,
    size: {
      [countries.US]: getSize(15.0, 15.0),
      [countries.UK]: getSize(15.0, 15.0),
      [countries.FR]: getSize(4.1, 5.2),
      [countries.EU]: getSize(4.1, 5.2),
      [countries.DE]: getSize(4.1, 5.2),
    },
    quantity: {
      [countries.US]: getHeadcountBasedQuantites(),
      [countries.UK]: getHeadcountBasedQuantites(),
      [countries.FR]: getHeadcountBasedQuantites(500, 500, 500),
      [countries.EU]: getHeadcountBasedQuantites(),
      [countries.DE]: getHeadcountBasedQuantites(),
    },
    imageUrl: {
      [countries.US]: '',
      [countries.UK]: '',
      [countries.FR]: 'https://res.cloudinary.com/jll-am-tenantrep/image/upload/f_auto/v1646737601/insite/prod/spaces/uyjktvdufrurhhekxrdj.jpg',
      [countries.EU]: '',
      [countries.DE]: '',
    },
    countries: [countries.FR],
  },
  {
    id: 2,
    name: 'spaceTypes.specific.unionsRooms',
    displayOrder: 2,
    spaceTypeId: spaceTypes.specific.id,
    size: {
      [countries.US]: getSize(15.0, 15.0),
      [countries.UK]: getSize(15.0, 15.0),
      [countries.FR]: getSize(4.1, 5.2),
      [countries.EU]: getSize(4.1, 5.2),
      [countries.DE]: getSize(4.1, 5.2),
    },
    quantity: {
      [countries.US]: getHeadcountBasedQuantites(),
      [countries.UK]: getHeadcountBasedQuantites(),
      [countries.FR]: getHeadcountBasedQuantites(500, 500, 500),
      [countries.EU]: getHeadcountBasedQuantites(),
      [countries.DE]: getHeadcountBasedQuantites(),
    },
    imageUrl: {
      [countries.US]: '',
      [countries.UK]: '',
      [countries.FR]: 'https://res.cloudinary.com/jll-am-tenantrep/image/upload/f_auto%2cq_80/v1556315894/insite/prod/spaces/wha1dxrejpym0rpbkzbp.png',
      [countries.EU]: '',
      [countries.DE]: '',
    },
    countries: [countries.FR],
  },
  {
    id: 3,
    name: 'spaceTypes.specific.employeesRooms',
    displayOrder: 3,
    spaceTypeId: spaceTypes.specific.id,
    size: {
      [countries.US]: getSize(15.0, 15.0),
      [countries.UK]: getSize(15.0, 15.0),
      [countries.FR]: getSize(4.1, 5.2),
      [countries.EU]: getSize(4.1, 5.2),
      [countries.DE]: getSize(4.1, 5.2),
    },
    quantity: {
      [countries.US]: getHeadcountBasedQuantites(),
      [countries.UK]: getHeadcountBasedQuantites(),
      [countries.FR]: getHeadcountBasedQuantites(500, 500, 500),
      [countries.EU]: getHeadcountBasedQuantites(),
      [countries.DE]: getHeadcountBasedQuantites(),
    },
    imageUrl: {
      [countries.US]: '',
      [countries.UK]: '',
      [countries.FR]: 'https://res.cloudinary.com/jll-am-tenantrep/image/upload/f_auto%2cq_80/v1556315894/insite/prod/spaces/wha1dxrejpym0rpbkzbp.png',
      [countries.EU]: '',
      [countries.DE]: '',
    },
    countries: [countries.FR],
  },
];
